import React, { useEffect, useRef, useState, useContext } from "react";
import Footer12 from "../shared/Footer12";
import Navbar12 from "../shared/Navbar12";
import Sidebar12 from "../shared/Sidebar12";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import Swal from "sweetalert2";
import { ContextBoard } from "../../context/ContextBoard";

function Addimprovement12() {
  const {
    setCandidateid12,
    setMode12,
    setDivyangcode12,
    setCastecode12,
    setClass12regulardata,
  } = useContext(ContextBoard);
  const navigate = useNavigate();
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [enddate, setEnddate] = useState("");
  // Form state
  const [formData, setFormData] = useState({
    passingYear: "2025",
    session: "",
    rollCode: "",
    rollNumber: "",
    reg1: "",
    reg2: "",
    reg3: "",
    registration_number4: "",
  });

  const reg2Ref = useRef(null);
  const reg3Ref = useRef(null);
  const token = sessionStorage.getItem("tokenclassxii");
  useEffect(() => {
    setCandidateid12("");
    setDivyangcode12("");
    setCastecode12("");
    setMode12("");
    const fetchSessions = async () => {
      try {
        const schoolCode = sessionStorage.getItem("schoolCode");

        const res = await fetch(
          `${config.API_BASE_URL}/PageloadRegistrationSessionEXRegular_CL12?type=B`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            // body: JSON.stringify({ schoolCode }),
          }
        );

        if (!res.ok) {
          throw new Error("Failed to fetch sessions");
        }

        const data = await res.json();
        setEnddate(
          data.data.sessionExRegular_data.registrationEndDate.registratioN_END
        );
        setSessions(data.data.sessionExRegular_data.sessionlist);
      } catch (error) {
        console.error("Error fetching sessions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSessions();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // const numericValue = value.replace(/\D/g, "");

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "reg1" && value.length === 5) {
      reg2Ref.current.focus();
    }
    if (name === "reg2" && value.length === 4) {
      reg3Ref.current.focus();
    }
  };

  const handleBackspace = (e, fieldName) => {
    if (e.key === "Backspace" && formData[fieldName] === "") {
      if (fieldName === "reg3") {
        reg2Ref.current.focus();
      } else if (fieldName === "reg2") {
        document.querySelector("input[name='reg1']").focus();
      }
    }
  };
  const updatedLateralstatus = sessionStorage.getItem("Class12LateralStatus");
  const handleValidate = async () => {
    const { passingYear, session, rollCode, rollNumber, reg1, reg2, reg3 } =
      formData;

    if (
      !passingYear ||
      !session ||
      !rollCode ||
      !rollNumber ||
      !reg1 ||
      !reg2 ||
      !reg3
    ) {
      return Swal.fire(
        "Missing Fields",
        "Please fill all required fields.",
        "warning"
      );
    }

    if (reg1.length !== 5 || reg2.length !== 4 || reg3.length !== 2) {
      return Swal.fire(
        "Invalid Registration",
        "Registration number must be 5 + 5 + 2 digits.",
        "error"
      );
    }
    const apiUrl =
      updatedLateralstatus === "ON"
        ? `FetchBettermentData_CL12Lateral`
        : `FetchBettermentData_CL12`;
    try {
      const token = sessionStorage.getItem("tokenclassxii");
      const res = await fetch(`${config.API_BASE_URL}/${apiUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          passingYear: passingYear,
          registrationSession: session,
          rollCode: rollCode,
          rollNo: rollNumber,
          registrationNo: `${reg1}-${formData.registration_number4}-${reg2}-${reg3}`,
        }),
      });

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.message || "Validation failed");
      }

      const result = await res.json();

      // Swal.fire("Success", "Student validated successfully.", "success").then(
      //   () => {
      navigate("/class-xii-add-improvement-info", {
        state: { studentData: result.data },
      });
      //   }
      // );
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error", error.message, "error");
    }
  };

  return (
    <>
      <div className="container-scroller">
        <Navbar12 />
        <div className="container-fluid page-body-wrapper">
          <Sidebar12 />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 mb-1">
                  <section className="content-header">
                    <h1>
                      <i className="fa fa-user-plus"></i>&nbsp; Add Improvement
                      Student (Student Registration Page for Board Examination)
                    </h1>
                    <ol className="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/class-xii-dashboard");
                          }}
                        >
                          Home&nbsp;
                        </a>
                      </li>
                      <li className="active"> Add Student</li>
                    </ol>
                  </section>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 mb-4 stretch-card">
                  <div className="card">
                    <div className="card-header card-green">
                      <h4 className="mb-0 p-2">Class XII Passing Details</h4>
                    </div>
                    <div className="card-body">
                      <div
                        className="row d-flex"
                        style={{ justifyContent: "center" }}
                      >
                        <div className="col-md-10 py-3">
                          <div className="row">
                            <label className="col-md-3">Passing Year :</label>
                            <div className="col-md-2">
                              <input
                                type="text"
                                className="form-control form-control-xs"
                                value={formData.passingYear}
                                disabled
                              />
                            </div>
                          </div>

                          <div className="row mt-3">
                            <label className="col-md-3">
                              Registration Session :{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="col-md-2">
                              <select
                                className="form-select form-select-xs"
                                name="session"
                                value={formData.session}
                                onChange={handleChange}
                                required
                              >
                                <option value="">Select</option>
                                {loading ? (
                                  <option>Loading...</option>
                                ) : (
                                  sessions.map((session) => (
                                    <option
                                      key={session.sessioN_CODE}
                                      value={session.sessioN_CODE}
                                    >
                                      {session.sessioN_FULL_NAME}
                                    </option>
                                  ))
                                )}
                              </select>
                            </div>
                          </div>

                          <div className="row mt-3">
                            <label className="col-md-3">
                              Roll Code: <span className="text-danger">*</span>
                            </label>
                            <div className="col-md-3">
                              <input
                                className="form-control form-control-xs"
                                name="rollCode"
                                maxLength="5"
                                value={formData.rollCode}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*$/.test(value)) {
                                    handleChange(e);
                                  }
                                }}
                              />
                            </div>
                          </div>

                          <div className="row mt-3">
                            <label className="col-md-3">
                              Roll Number:{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="col-md-3">
                              <input
                                className="form-control form-control-xs"
                                name="rollNumber"
                                maxLength="5"
                                value={formData.rollNumber}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*$/.test(value)) {
                                    handleChange(e);
                                  }
                                }}
                                inputMode="numeric"
                                pattern="[0-9]*"
                              />
                            </div>
                          </div>

                          <div className="row mt-3">
                            <label className="col-md-3">
                              Registration Number:{" "}
                              <span className="text-danger">*</span>
                            </label>

                            <div className="col-md-2">
                              <input
                                className="form-control form-control-xs"
                                name="reg1"
                                value={formData.reg1}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*$/.test(value)) {
                                    handleChange(e);
                                  }
                                }}
                                onKeyDown={(e) => handleBackspace(e, "reg1")}
                                maxLength="5"
                                inputMode="numeric"
                                pattern="[0-9]*"
                              />
                              <p>5 Digits Only</p>
                            </div>
                            <div class="col-md-2">
                              <select
                                id="registration_number4"
                                name="registration_number4"
                                className="form-control form-select form-control-xs"
                                value={formData.registration_number4} // <-- bind value
                                onChange={handleChange} // <-- use the same handler
                                required
                              >
                                <option value="">Select</option>
                                <option value="RS">RS</option>
                                <option value="RC">RC</option>
                                <option value="RA">RA</option>
                                <option value="PC">PC</option>
                                <option value="PA">PA</option>
                              </select>
                            </div>
                            <div className="col-md-2">
                              <input
                                className="form-control form-control-xs"
                                name="reg2"
                                value={formData.reg2}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*$/.test(value)) {
                                    handleChange(e);
                                  }
                                }}
                                onKeyDown={(e) => handleBackspace(e, "reg2")}
                                maxLength="4"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                ref={reg2Ref}
                              />
                              <p>4 Digits Only</p>
                            </div>

                            <div className="col-md-2">
                              <input
                                className="form-control form-control-xs"
                                name="reg3"
                                value={formData.reg3}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*$/.test(value)) {
                                    handleChange(e);
                                  }
                                }}
                                onKeyDown={(e) => handleBackspace(e, "reg3")}
                                maxLength="2"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                ref={reg3Ref}
                              />
                              <p>2 Digits Only</p>
                            </div>
                          </div>

                          <div className="row mt-3">
                            <div className="col-md-3"></div>
                            <div className="col-md-offset-3 col-md-8">
                              <div className="row">
                                <div className="col-md-8">
                                  <button
                                    type="button"
                                    className="btn btn-block btn-xs proceed-btn"
                                    onClick={handleValidate}
                                    style={{
                                      fontSize: "16px",
                                      padding: "8px",
                                      backgroundColor: "#FF0000",
                                      color: "white",
                                      fontWeight: "600",
                                    }}
                                    id="validate"
                                  >
                                    CLICK HERE TO VALIDATE &amp; PROCEED
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer12 />
          </div>
        </div>
      </div>
    </>
  );
}

export default Addimprovement12;
